// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as SvgImages$LiveRoom from "./assets/img/SvgImages.bs.js";
import * as SterlingTokens$LiveRoom from "./bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "./styles/StyleConstants.bs.js";

var outerContainer = Curry._1(Css.style, {
      hd: Css.display(Css.flexBox),
      tl: {
        hd: Css.justifyContent(Css.center),
        tl: /* [] */0
      }
    });

function container(multiplier) {
  var calculatedWidth = multiplier * 44 | 0;
  return Curry._1(Css.style, {
              hd: Css.display(Css.flexBox),
              tl: {
                hd: Css.alignItems(Css.center),
                tl: {
                  hd: Css.justifyContent(Css.spaceBetween),
                  tl: {
                    hd: Css.width(Css.px(calculatedWidth)),
                    tl: /* [] */0
                  }
                }
              }
            });
}

function dotContainer(multiplier) {
  return Curry._1(Css.style, {
              hd: Css.width(Css.px(12 * multiplier | 0)),
              tl: {
                hd: Css.height(Css.px(12 * multiplier | 0)),
                tl: {
                  hd: Css.display(Css.flexBox),
                  tl: {
                    hd: Css.alignItems(Css.center),
                    tl: {
                      hd: Css.justifyContent(Css.center),
                      tl: {
                        hd: Css.selector("div", {
                              hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                              tl: {
                                hd: Css.borderRadius(Css.px(4 * multiplier | 0)),
                                tl: {
                                  hd: Css.width(Css.px(8 * multiplier | 0)),
                                  tl: {
                                    hd: Css.height(Css.px(8 * multiplier | 0)),
                                    tl: {
                                      hd: Css.opacity(0.2),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

var dotAnimation = Curry._1(Css.keyframes, {
      hd: [
        0,
        {
          hd: Css.opacity(0.2),
          tl: {
            hd: Css.transform({
                  NAME: "scale",
                  VAL: [
                    0.66,
                    0.66
                  ]
                }),
            tl: /* [] */0
          }
        }
      ],
      tl: {
        hd: [
          25,
          {
            hd: Css.opacity(1),
            tl: {
              hd: Css.transform({
                    NAME: "scale",
                    VAL: [
                      1,
                      1
                    ]
                  }),
              tl: /* [] */0
            }
          }
        ],
        tl: {
          hd: [
            50,
            {
              hd: Css.opacity(1),
              tl: {
                hd: Css.transform({
                      NAME: "scale",
                      VAL: [
                        1,
                        1
                      ]
                    }),
                tl: /* [] */0
              }
            }
          ],
          tl: {
            hd: [
              75,
              {
                hd: Css.opacity(0.2),
                tl: {
                  hd: Css.transform({
                        NAME: "scale",
                        VAL: [
                          0.66,
                          0.66
                        ]
                      }),
                  tl: /* [] */0
                }
              }
            ],
            tl: {
              hd: [
                100,
                {
                  hd: Css.opacity(0.2),
                  tl: {
                    hd: Css.transform({
                          NAME: "scale",
                          VAL: [
                            0.66,
                            0.66
                          ]
                        }),
                    tl: /* [] */0
                  }
                }
              ],
              tl: /* [] */0
            }
          }
        }
      }
    });

var one = Curry._1(Css.style, {
      hd: Css.animationName(dotAnimation),
      tl: {
        hd: Css.animationDuration({
              NAME: "ms",
              VAL: 1400
            }),
        tl: {
          hd: Css.animationIterationCount("infinite"),
          tl: {
            hd: Css.animationTimingFunction("easeInOut"),
            tl: /* [] */0
          }
        }
      }
    });

var two = Curry._1(Css.merge, {
      hd: one,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.animationDelay({
                    NAME: "ms",
                    VAL: 233
                  }),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var three = Curry._1(Css.merge, {
      hd: one,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.animationDelay({
                    NAME: "ms",
                    VAL: 466
                  }),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

function Loader$Ellipsis(props) {
  var size = props.size;
  var size$1 = size !== undefined ? size : 1;
  return React.createElement("div", {
              className: outerContainer
            }, React.createElement("div", {
                  className: container(size$1)
                }, React.createElement("div", {
                      className: dotContainer(size$1)
                    }, React.createElement("div", {
                          className: one
                        })), React.createElement("div", {
                      className: dotContainer(size$1)
                    }, React.createElement("div", {
                          className: two
                        })), React.createElement("div", {
                      className: dotContainer(size$1)
                    }, React.createElement("div", {
                          className: three
                        }))));
}

var Ellipsis = {
  outerContainer: outerContainer,
  container: container,
  dotContainer: dotContainer,
  dotAnimation: dotAnimation,
  one: one,
  two: two,
  three: three,
  make: Loader$Ellipsis
};

var loadingStyle = Curry._1(Css.style, {
      hd: Css.position("fixed"),
      tl: {
        hd: Css.top(Css.px(0)),
        tl: {
          hd: Css.left(Css.px(0)),
          tl: {
            hd: Css.zIndex(10000),
            tl: {
              hd: Css.width(Css.vw(100)),
              tl: {
                hd: Css.height(Css.vh(100)),
                tl: {
                  hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                  tl: {
                    hd: Css.opacity(1),
                    tl: {
                      hd: Css.display("flex"),
                      tl: {
                        hd: Css.justifyContent("center"),
                        tl: {
                          hd: Css.alignItems("center"),
                          tl: {
                            hd: Css.transition(StyleConstants$LiveRoom.animationMedium, StyleConstants$LiveRoom.animationFast, undefined, "opacity"),
                            tl: {
                              hd: Css.fontSize(Css.px(32)),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var logoStyle = Curry._1(Css.style, {
      hd: Css.opacity(1),
      tl: {
        hd: Css.transform({
              NAME: "scale",
              VAL: [
                1,
                1
              ]
            }),
        tl: {
          hd: Css.transition(StyleConstants$LiveRoom.animationMedium, undefined, undefined, "all"),
          tl: /* [] */0
        }
      }
    });

var innerContainer = Curry._1(Css.style, {
      hd: Css.marginTop(Css.vh(-10)),
      tl: /* [] */0
    });

var ellipsisStyle = Curry._1(Css.style, {
      hd: Css.opacity(1),
      tl: {
        hd: Css.transform({
              NAME: "scale",
              VAL: [
                1,
                1
              ]
            }),
        tl: {
          hd: Css.transition(StyleConstants$LiveRoom.animationMedium, undefined, undefined, "all"),
          tl: /* [] */0
        }
      }
    });

function Loader(props) {
  return React.createElement("div", {
              className: loadingStyle
            }, React.createElement("div", {
                  className: innerContainer
                }, React.createElement("div", {
                      className: logoStyle
                    }, React.createElement(SvgImages$LiveRoom.SothebysLogo.make, {})), React.createElement("div", {
                      className: ellipsisStyle
                    }, React.createElement(Loader$Ellipsis, {}))));
}

var make = Loader;

export {
  Ellipsis ,
  loadingStyle ,
  logoStyle ,
  innerContainer ,
  ellipsisStyle ,
  make ,
}
/* outerContainer Not a pure module */
